import React from "react";
import { Link } from "react-router-dom";

function CountDownSection() {
  return (
    <div>
      <div className="countdown-section">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-lg-5">
              <div className="section-heading">
                <div
                  className="sub-title text-white wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="300ms"
                >
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Countdown
                </div>
                <h2
                  className="text-white mb-3 wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="500ms"
                >
                  Elevate your career with Paraclearth.
                </h2>
                <p
                  className="text-white wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  At Express Travel, we believe in the transformative power of
                  travel. As avid explorers ourselves, we understand the desire
                  to uncover experiences, forge desire meaningful.
                </p>
                <Link
                  to="#"
                  className="btn btn-primary mt-5 wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="900ms"
                >
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className="col-lg-1 col-xl-2"></div>

            <div className="col-12 col-lg-6 col-xl-5">
              {/* Countdown Card */}
              <div className="countdown-card">
                <div className="row g-4 align-items-center">
                  <div className="col-12 col-sm-6">
                    {/* Countdown Card Item */}
                    <div
                      className="countdown-card-item mb-4 wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay="300ms"
                    >
                      <h2 className="mb-2">
                        <span>450</span>
                      </h2>
                      <p className="mb-0">Projects Done</p>
                    </div>

                    {/* Countdown Card Item */}
                    <div
                      className="countdown-card-item wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay="500ms"
                    >
                      <h2 className="mb-2">
                        <span>96</span>%
                      </h2>
                      <p className="mb-0">Client Satisfaction</p>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6">
                    {/* Countdown Card Item */}
                    <div
                      className="countdown-card-item wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay="700ms"
                    >
                      <h2 className="mb-2">
                        <span>90</span>k
                      </h2>
                      <p className="mb-0">Happy Customers</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default CountDownSection;
